// extracted by mini-css-extract-plugin
export default {"container":"S9iPV ZdH1P","header":"xosUI","slide":"U9ScA"};